(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/hbs-helpers.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/hbs-helpers.js');

'use strict';

var _require;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var loggerId = 'components:content:image-v2';
var cmsImagePrefix = '/cms/images';
var _svs = svs,
  isServer = _svs.isServer;
var _svs$utils = svs.utils,
  svsuid = _svs$utils.svsuid,
  getFileFormat = _svs$utils.getFileFormat;
var trinidad = isServer && ((_require = require('trinidad-core')) === null || _require === void 0 ? void 0 : _require.core);
var _ref = isServer ? require("".concat(__dirname, "/to-array-or-null.es6")) : svs.content.image_v2.helpers,
  toArrayOrNull = _ref.toArrayOrNull;
var logger = isServer ? trinidad.logger(loggerId) : new svs.core.log.Logger(loggerId);
var allowedMimeTypes = ['image/avif', 'image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'];

var getUrlWithCorrectHost = function getUrlWithCorrectHost(url, config) {
  if (!url) {
    return '';
  }
  return url.startsWith('http') ? url : "".concat(config.options.cdn2).concat(url);
};

var getUrlWithFilledPlaceholders = function getUrlWithFilledPlaceholders(url, width, extension) {
  var picassoData = "".concat(width, "/").concat(extension);
  url = url.replace(RegExp("^".concat(cmsImagePrefix)), "".concat(cmsImagePrefix, "/").concat(picassoData));
  return url;
};

var getWithFilledPlaceholders = function getWithFilledPlaceholders(url, width, extension) {
  url = url.replace('{width}', width);
  url = url.replace('{extension}', extension);
  return url;
};

var getUrl = function getUrl(image, extension, width) {
  var _image$url, _extension;
  var url;
  url = (image === null || image === void 0 || (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.replace(/-({width}|%7Bwidth%7D)/g, '')) || '';
  url = getWithFilledPlaceholders(url, width, extension);
  if (image !== null && image !== void 0 && image.isPreview && !extension) {
    return url;
  }
  extension = ((_extension = extension) === null || _extension === void 0 ? void 0 : _extension.replace(/\./g, '')) || 'original';
  width = image !== null && image !== void 0 && image.originalImage ? 'original' : width;
  return getUrlWithFilledPlaceholders(url, width, extension);
};

var getSrcsetString = function getSrcsetString(image, extension, width, config) {
  var _image$availableForma;
  var output;

  output = getUrl(image, extension || ((_image$availableForma = image.availableFormats) === null || _image$availableForma === void 0 || (_image$availableForma = _image$availableForma[0]) === null || _image$availableForma === void 0 ? void 0 : _image$availableForma.extension) || 'webp', width);

  output = getUrlWithCorrectHost(output, config);

  output = "".concat(output).concat(isNaN(width) ? ' ' : " ".concat(width, "w"));
  return output;
};

function registerHelpers(hbs, config) {
  var handlebarsHelpers = {
    contentImageHeight: function contentImageHeight(context) {
      var _ref2 = context || null,
        height = _ref2.height,
        width = _ref2.width;
      var fallbackHeight = 43.75;
      return width && height ? height / width * 100 : fallbackHeight;
    },
    getUniqueSelector: function getUniqueSelector() {
      return "image-".concat(svsuid());
    },
    getSrcset: function getSrcset(image, extension) {
      var _image$availableWidth;
      var srcsetArray = (image === null || image === void 0 || (_image$availableWidth = image.availableWidths) === null || _image$availableWidth === void 0 ? void 0 : _image$availableWidth.map(function (width) {
        return getSrcsetString(image, extension, width, config);
      })) || getUrlWithCorrectHost(getUrl(image, extension), config);
      return new hbs.SafeString(srcsetArray.toString());
    },
    setVar: function setVar(name, value) {
      this[name] = value;
    },
    getSourceElementsData: function getSourceElementsData(image) {
      var _getFileFormat;
      var loadingLazy = image.loadingLazy,
        url = image.url,
        media = image.media,
        imageSizes = image.sizes;

      var originalFormat = {
        extension: 'original',
        mimeType: (_getFileFormat = getFileFormat(url)) === null || _getFileFormat === void 0 ? void 0 : _getFileFormat.mimeType
      };

      var formats = originalFormat.mimeType === 'image/svg+xml' ? [originalFormat] : [getFileFormat('webp'), originalFormat];
      var sourcesData = formats.map(function (_ref3) {
        var extension = _ref3.extension,
          mimeType = _ref3.mimeType;
        var getSrcset = handlebarsHelpers.getSrcset;
        var id = svsuid();
        var dataSrc = loadingLazy ? getSrcset(image, extension) : null;
        var srcSet = !loadingLazy ? getSrcset(image, extension) : null;
        var type = mimeType;
        var sizesFallback = '100vw';
        var sizes = imageSizes || sizesFallback;
        if (!allowedMimeTypes.includes(mimeType)) {
          logger.warn("The MIME type `".concat(mimeType, "` is not supported. ") + "Supported MIME types: `".concat(allowedMimeTypes.join('`, `'), "`. ") + "Image URL: `".concat(url, "`."));
        }
        return {
          id: id,
          dataSrc: dataSrc,
          media: media,
          sizes: sizes,
          srcSet: srcSet,
          type: type
        };
      });
      return sourcesData;
    },
    stringifyImagesObject: function stringifyImagesObject(input) {
      var imagesArray = toArrayOrNull(input);
      if (imagesArray) {
        var customImagesArray = imagesArray.map(function (item) {
          return item ? {
            aspectRatio: item.aspectRatio,
            dominantColor: item.dominantColor,
            media: item.media
          } : undefined;
        });
        return JSON.stringify(customImagesArray);
      }
      return null;
    },
    setStyleElement: function setStyleElement(selector, imagesObject) {
      if (svs.isBrowser) {
        var setStyleElement = svs.content.image_v2.helpers.multiImageStyleElement.setStyleElement;
        setStyleElement(selector, imagesObject);
      }
    },
    getNoscriptUrl: function getNoscriptUrl(image, images, noscriptUrl, isMultiImage) {
      var getWidestItem = function getWidestItem(items) {
        return (items === null || items === void 0 ? void 0 : items.reduce(function (prev, curr) {
          return (prev === null || prev === void 0 ? void 0 : prev.width) > (curr === null || curr === void 0 ? void 0 : curr.width) ? prev : curr;
        }, {
          width: 0
        })) || null;
      };
      var $noscriptUrl = isMultiImage ? noscriptUrl : image === null || image === void 0 ? void 0 : image.noscriptUrl;

      var getMultiImageFallback = function getMultiImageFallback() {
        return getWidestItem(images && Object.values(images));
      };
      var getFallbackUrl = function getFallbackUrl() {
        var _fallbackImage$availa, _fallbackImage$availa2;
        var fallbackImage = isMultiImage ? getMultiImageFallback() : image;
        var highestWidth = fallbackImage !== null && fallbackImage !== void 0 && (_fallbackImage$availa = fallbackImage.availableWidths) !== null && _fallbackImage$availa !== void 0 && _fallbackImage$availa.includes('original') || fallbackImage !== null && fallbackImage !== void 0 && fallbackImage.originalImage ? 'original' : Math.max.apply(Math, _toConsumableArray((fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.availableWidths) || [0]));
        var extension = fallbackImage === null || fallbackImage === void 0 || (_fallbackImage$availa2 = fallbackImage.availableFormats) === null || _fallbackImage$availa2 === void 0 || (_fallbackImage$availa2 = _fallbackImage$availa2[0]) === null || _fallbackImage$availa2 === void 0 ? void 0 : _fallbackImage$availa2.extension;
        return getUrl(fallbackImage, extension, highestWidth);
      };
      var url = $noscriptUrl || getFallbackUrl();
      return getUrlWithCorrectHost(url, config);
    }
  };

  for (var helperName in handlebarsHelpers) {
    if (helperName in handlebarsHelpers) {
      hbs.registerHelper(helperName, handlebarsHelpers[helperName]);
    }
  }
}
if (isServer) {
  var _require2 = require('trinidad-core'),
    core = _require2.core;
  registerHelpers(require('hbs'), core.config);
} else {
  var _svs$core;
  var config = {
    options: (_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.config) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.svsconfig
  };
  registerHelpers(Handlebars, config);
}

 })(window);